import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/lp/intelligent-pr")({
  component: () => <Outlet />,
});
